React = require 'react'
$ = require 'jquery'
Util = require 'lib/util'
Auth = require 'db/auth'
Dialog = require 'views/lib/dialog'
t = require('views/internal/recup-with-helpers')('home')
CreateBoardComponent = require 'views/board-create/create-board-component'
{
  CreateBoardOrientationCard
  CreateTeamBoardOrientationCard
} = require './presentational/orientation-card'
{ maybeDisplayMemberLimitsError } = require 'views/board-menu/member-limits-error'

module.exports = class NewUserOrientationCard extends React.Component
  displayName: 'NewUserOrientationCard'

  constructor: (props) ->
    super props

    @onCreateBoardClick = @onCreateBoardClick.bind(@)
    @onCreateTeamBoardClick = @onCreateTeamBoardClick.bind(@)
    @onBoardNameChange = @onBoardNameChange.bind(@)

    @state = {
      boardName: ''
      isCreating: false
    }

  onBoardNameChange: (boardName) ->
    @setState boardName: boardName

  onCreateBoardClick: ->

    name = @state.boardName.trim()
    trackingOpts = { category: 'home', method: 'by clicking create your board button in new user card' }
    @props.onCreateBoardClick({ name, trackingOpts })
    @setState isCreating: true

  onCreateTeamBoardClick: (e) ->
    if maybeDisplayMemberLimitsError($(e.target), null, Auth.me())
      return

    Dialog.show
      displayType: 'mod-no-chrome'
      opacity: 0.75
      reactElement: React.createElement CreateBoardComponent,
        defaultOrg: @props.currentOrg
        trackingOpts: { category: 'home', method: 'by clicking create a team board button in new user card' }

  render: t.renderable ->
    { onHomeTab, onDismissClick } = @props
    { boardName, isCreating } = @state

    if onHomeTab
      t.tag CreateBoardOrientationCard, {
        @onCreateBoardClick
        onDismissClick
        boardName
        @onBoardNameChange
        autofocus: true
        inputDisabled: isCreating
        buttonDisabled: !boardName.trim() || isCreating
      }
    else
      t.tag CreateTeamBoardOrientationCard, {
        @onCreateTeamBoardClick
        onDismissClick
      }



// WEBPACK FOOTER //
// ./app/scripts/views/home/new-user-orientation-card.coffee